export const MONITORING = "MONITORING";
export const APPROACHING = "APPROACHING";
export const EXPOSED = "EXPOSED";
export const REGISTERING = "REGISTERING";
export const REMITTING = "REMITTING";
export const EXEMPT = "EXEMPT";

export const NEXUS_TYPE_ECONOMIC = "Economic";
export const NEXUS_TYPE_PHYSICAL = "Physical";
